import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import { Api } from '../api';
import { AppState } from './models/app-state';
import { StoreConfigurationFunction } from './models/store-configuration-function';
import { rootReducer } from '../reducer';

export const configureStore: StoreConfigurationFunction = (api: Api, preloadedState: Partial<AppState> = {}) =>
    createStore(rootReducer, preloadedState, applyMiddleware(thunk.withExtraArgument({ api })));
